import actions from 'actions'
import { RootStateOrAny } from 'react-redux'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'

import { menuFetcherV3, MenuRequestParamsV3 } from '@library/menu-service'

import { menuServiceV3DataReceived } from 'actions/menu/menuV3'

export const fetchMenuV3 =
  (params: MenuRequestParamsV3, isPreviewMode = false) =>
  async (dispatch: ThunkDispatch<RootStateOrAny, unknown, AnyAction>): Promise<void> => {
    const menuResponseV3 = await menuFetcherV3({
      deliveryDate: params.deliveryDate,
      numPortions: params.numPortions,
      includeRecipeGroups: params.includeRecipeGroups,
      includeIngredientCustomisations: params.includeIngredientCustomisations,
      motivationIds: params.motivationIds,
      'preview[menu_id]': params['preview[menu_id]'],
      'preview[auth_user_id]': params['preview[auth_user_id]'],
      'preview[expiry]': params['preview[expiry]'],
      'preview[signature]': params['preview[signature]'],
    })

    if (isPreviewMode) {
      dispatch(actions.basketDateChange(menuResponseV3.period.when_cutoff.split('T')[0]))
    }

    dispatch(
      menuServiceV3DataReceived(
        {
          deliveryDate: params.deliveryDate,
          numPortions: params.numPortions,
        },
        menuResponseV3,
      ),
    )
  }
